<template>
    <div id="app">
        <router-view />
        <fullscreen />
        <!-- <div @click="addAudioData" class="add-audio-data">点击发送测试音频附件</div> -->
        <!-- <div @click="addAudioData" class="add-audio-data">点击发送答疑show</div> -->
        <!-- <div @click="addImgData" class="add-audio-data">点击发送测试图片附件</div> 
        <div @click="closeImgData" class="add-audio-data data2">点击关闭图片附件</div>  -->
    </div>
</template>

<script>
import fullscreen from '@/components/fullScreen';
import audioData from '@/assets/json/quiz-audio.json';
import imageData from '@/assets/json/hw-files.json';
import closeData from '@/assets/json/close-files.json';
import qa from '@/assets/json/qa.json';

export default {
    name: 'App',
    components: {
        fullscreen
    },

    data: function() {
        return {
            audioData: audioData,
            imageData: imageData
        };
    },

    provide:function() {
        return{
            reload: this.reload
        };
    },

    

    created: function() {

    },

    methods: {
        reload () {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },

        addAudioData: function() {
            window.parent.postMessage(qa,'*');
        },

        addImgData: function() {
            window.parent.postMessage(imageData,'*');
        },

        closeImgData: function() {
            window.parent.postMessage(closeData,'*');
        }
    }
};
</script>

<style>
    #app {
        /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
        font-family: "Helvetica Neue", Helvetica, arial, "Pingfang SC", '微软雅黑', STHeiTi, 'Microsoft Yahei', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .add-audio-data {
        width: 100px;
        height: 50px;
        background: #cccccc;
        position: fixed;
        top: 50%;
        right: 0;
        z-index: 99999;
    }

    .data2 {
        position: fixed;
        top: 60%;
        right: 0;
    }
</style>
